import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/h5/login',
    name: 'H5Login',
    component: () => import('@/views/h5/Login')
  },
  {
    path: '/h5/register',
    name: 'H5Register',
    component: () => import('@/views/h5/Register')
  },
  {
    path: '/h5/cardList',
    name: 'H5CardList',
    component: () => import('@/views/h5/card-management/list/index.vue')
  },
  {
    path: '/h5/cardCreate',
    name: 'H5CardCreate',
    component: () => import('@/views/h5/card-management/create/index.vue')
  },
  {
    path: '/h5/cardDetail',
    name: 'H5CardDetail',
    component: () => import('@/views/h5/card-management/detail/index.vue')
  },
  {
    path: '/h5/my',
    name: 'H5My',
    component: () => import('@/views/h5/my/index.vue')
  },
  {
    path: '/h5/:id',
    name: 'CardView',
    component: () => import('@/views/h5/CardView')
  },
  {
    path: '/v',
    name: 'ViewCardDetail',
    component: () => import('@/views/h5/v/index')
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/Login')
  },
  {
    path: '/admin/register',
    name: 'AdminRegister',
    component: () => import('@/views/admin/Register')
  },
  {
    path: '/admin/forgot-password',
    name: 'AdminForgotPassword',
    component: () => import('@/views/admin/ForgotPassword')
  },
  {
    path: '/admin',
    component: () => import('@/layout/Index'),
    redirect: '/admin/cardList',
    meta: { requiresAuth: true },
    children: [
      { path: 'cardCreate', component: () => import('@/views/admin/card-management/create/index.vue'), meta: { title: 'createTitle' } },
      { path: 'cardList', component: () => import('@/views/admin/card-management/list/index.vue'), meta: { title: 'myECard' } },
      { path: 'cardDetail', component: () => import('@/views/admin/card-management/detail/index.vue'), meta: { title: 'cardDetail' } },
      { path: 'customerManagement', component: () => import('@/views/admin/customer-management/index.vue'), meta: { title: 'customerManagement' } },
      { path: 'my', component: () => import('@/views/admin/my/index.vue'), meta: { title: 'my' } },
      { path: 'companyInfo', component: () => import('@/views/admin/company-management/companyInfo/index.vue'), meta: { title: 'companyInfo' } },
      { path: 'companyInfo/employee', component: () => import('@/views/admin/company-management/employee/index.vue'), meta: { title: 'employeeManagement' } },
      { path: 'userManagement', component: () => import('@/views/admin/user-management/index.vue'), meta: { title: 'userManagement' } },
    ]
  },
  {
    path: '/',
    redirect: '/admin/login'
  },
  // 404 页面 → 解决刷新跳转问题
  {
    path: '*',
    redirect: to => {
      // 如果是 h5 页面刷新，留在 h5
      if (to.path.startsWith('/h5') || to.path.startsWith('/v')) {
        return to.fullPath
      }
      // 其他页面跳登录
      return '/admin/login'
    }
  }
]

const router = new VueRouter({
  mode: 'hash', // 使用 hash 模式  \ history 模式需要服务器支持
  base: process.env.BASE_URL,
  routes
})




// ==========================================
// ✅ 最终版：PC ↔ H5 双向自动互跳
// ==========================================

/**
 * @description 检查是否需要跳转
 * @param {*} to 路由对象
 * @returns {Object|null} 跳转对象或null
 */
function checkRedirect(to) {
  const width = window.innerWidth
  const isMobileSize = width < 768
  const path = to.path
  const query = { ...to.query } // 保留所有参数

  // 配置需要互跳的页面
  const routeMap = [
    { pc: '/admin/login', h5: '/h5/login' },
    { pc: '/admin/register', h5: '/h5/register' },
    { pc: '/admin/forgot-password', h5: '/h5/forgot-password' },
    { pc: '/admin/cardList', h5: '/h5/cardList' },
    { pc: '/admin/cardCreate', h5: '/h5/cardCreate' },
    { pc: '/admin/cardDetail', h5: '/h5/cardDetail' },
    { pc: '/admin/my', h5: '/h5/my' },
  ]


  const current = routeMap.find(item => path === item.pc || path === item.h5)
  console.log('current', isMobileSize, current)
  if (!current) return null

  if (isMobileSize && path === current.pc) {
    return { path: current.h5, query }
  }

  if (!isMobileSize && path === current.h5) {
    return { path: current.pc, query }
  }

  return null
}

// 设备切换刷新标志
let deviceSwitchPending = false

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('user_token')

  // 1. 权限校验逻辑
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      return next('/admin/login')
    }
  }
  if (
    to.path === '/admin/login' ||
    to.path === '/admin/register' ||
    to.path === '/admin/forgot-password'
  ) {
    if (token) {
      return next('/admin')
    }
  }

  // 2. 设备互跳逻辑（关键：只在首次进入时执行，不循环）
  if (from.path === '/' || from.path !== to.path) { // 避免跳转后重复触发
    const redirect = checkRedirect(to)
    if (redirect) {
      // 设置刷新标志，然后跳转
      deviceSwitchPending = true
      return next(redirect)
    }
  }

  next()
})

/**
 * @description 路由切换完成后执行刷新
 */
router.afterEach(() => {
  // 检测设备切换标志
  if (deviceSwitchPending) {
    // 重置标志位（防止刷新后再次触发）
    deviceSwitchPending = false
    // 短暂延迟确保路由已经完全切换完成
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }
})

/**
 * @description 监听窗口变化，自动跳转并刷新
 */
let resizeTimer = null
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer)
  resizeTimer = setTimeout(() => {
    const redirect = checkRedirect(router.currentRoute)
    if (redirect) {
      // 设置刷新标志，然后跳转
      deviceSwitchPending = true
      router.replace(redirect)
    }
  }, 300)
})

export default router